// extracted by mini-css-extract-plugin
export default {"AIAssistWrapper":"_AIAssistWrapper--R1JIm","AIAssistContainer":"_AIAssistContainer--fVkuJ","NoBorder":"_NoBorder--hMPzb"};